import { XCircleIcon } from '@phosphor-icons/react/ssr';
import { ChangeEvent } from 'react';


type UseClearableInputProps = {
    value   : string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
}

export const useClearableInput = ({ value, onChange, onClear: onClearProp }: UseClearableInputProps) => {
    const onClear = () => {
        if (onClearProp) {
            onClearProp();
        } else {
            onChange({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
        }
    };

    return {
        value,
        onChange,
        onClear,
        Icon: XCircleIcon,
    };
};
